import { render, staticRenderFns } from "./ClassSchModal.vue?vue&type=template&id=650a660f&"
import script from "./ClassSchModal.vue?vue&type=script&lang=js&"
export * from "./ClassSchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports